export const FeatureKey = 'SummaryComputers';
export const FeaturePrefix = '[Summary Computer]';
